import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Download, X } from 'lucide-react';

interface VisualizadorEvidenciaProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  evidencia: {
    nombre: string;
    tipo: string;
    url?: string;
  } | null;
}

export const VisualizadorEvidencia = ({
  open,
  onOpenChange,
  evidencia,
}: VisualizadorEvidenciaProps) => {
  if (!evidencia) return null;

  const handleDescargar = () => {
    if (evidencia.url) {
      const link = document.createElement('a');
      link.href = evidencia.url;
      link.download = evidencia.nombre;
      link.click();
    }
  };

  const renderContenido = () => {
    if (!evidencia.url) {
      return (
        <div className="flex items-center justify-center h-96 text-muted-foreground">
          No hay vista previa disponible
        </div>
      );
    }

    // Imágenes
    if (evidencia.tipo.includes('image')) {
      return (
        <div className="flex items-center justify-center bg-gray-50 rounded-lg p-4">
          <img
            src={evidencia.url}
            alt={evidencia.nombre}
            className="max-w-full max-h-[70vh] object-contain"
          />
        </div>
      );
    }

    // PDFs
    if (evidencia.tipo.includes('pdf')) {
      return (
        <iframe
          src={evidencia.url}
          className="w-full h-[70vh] rounded-lg border"
          title={evidencia.nombre}
        />
      );
    }

    // Otros tipos de archivo
    return (
      <div className="flex flex-col items-center justify-center h-96 text-center space-y-4">
        <div className="text-muted-foreground">
          <p className="font-semibold mb-2">{evidencia.nombre}</p>
          <p className="text-sm">Vista previa no disponible para este tipo de archivo</p>
        </div>
        <Button onClick={handleDescargar}>
          <Download className="mr-2 h-4 w-4" />
          Descargar Archivo
        </Button>
      </div>
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh]">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle className="truncate pr-8">{evidencia.nombre}</DialogTitle>
            <div className="flex gap-2">
              <Button
                size="sm"
                variant="outline"
                onClick={handleDescargar}
              >
                <Download className="h-4 w-4 mr-2" />
                Descargar
              </Button>
            </div>
          </div>
        </DialogHeader>
        <div className="mt-4">
          {renderContenido()}
        </div>
      </DialogContent>
    </Dialog>
  );
};
